import React from 'react'
import { Tabs } from 'antd'
import type { TabsProps } from 'antd'

import { StatementsTab } from './tabs/statements'
import { PushTab } from './tabs/push'
import { EmailsTab } from './tabs/emails/component'

const items: TabsProps['items'] = [
  {
    key: 'statements',
    label: 'Statements',
    children: <StatementsTab />,
  },
  {
    key: 'emails',
    label: 'Emails',
    children: <EmailsTab />,
  },
  {
    key: 'push',
    label: 'Push',
    children: <PushTab />,
  },
]

export const Notifications: React.FC = () => {
  return <Tabs defaultActiveKey="statements" items={items} />
}
